
import { ReactNode } from "react";
import AdminHeader from "../organisms/AdminHeader";
import Footer from "../organisms/Footer";

type LayoutProps = {
  children: ReactNode;
};

export default function MainLayoutAdmin({ children }: LayoutProps) {
  return (
    <div className="min-h-screen flex flex-col">
      <AdminHeader />
      <main className="flex-1">{children}</main>
      <Footer/>
    </div>
  );
}
